import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import {
  serializeWorkOrderAmendmentWrite,
} from '#/api/momMgmt/workOrder/amendment/serialize';

/**
 * PATCH `/mom/work-order/{workOrderId}/amendment/{amendmentId}`。僅 DRAFT。
 *
 * @param {string} workOrderId
 * @param {string} amendmentId
 * @param {object} values
 */
export async function updateWorkOrderAmendment(workOrderId, amendmentId, values) {
  const { data: raw } = await request.patch(
    `/mom/work-order/${workOrderId}/amendment/${amendmentId}`,
    serializeWorkOrderAmendmentWrite(values),
  );
  return parseVer4DetailResponse(raw);
}
